import React from 'react';
import {useParams} from 'react-router-dom';

import {useGetSkillsQuery} from '../api/candidate';
import {
  useGetCompaniesDetailsQuery,
  useGetJobDetailsQuery,
} from '../api/employer';
import JobForm from './jobForm';

const EditJob = () => {
  const {jobId} = useParams();
  const {data, isLoading: isJobDetailsLoading} = useGetJobDetailsQuery(jobId);

  // list of all the skills
  const {data: skillData, isLoading: isSkillLoading} = useGetSkillsQuery();

  const {data: companiesList, isLoading: isCompanyLoading} =
    useGetCompaniesDetailsQuery();

  if (isJobDetailsLoading || isSkillLoading || isCompanyLoading) {
    return 'Loading...';
  }

  const jobDetails = data?.data || null;

  const allSkills = skillData?.data || [];
  const skillList = allSkills.reduce(
    (obj, item) => Object.assign(obj, {[item._id]: item.name}),
    {},
  );

  // we are filtering out the company based on current job's employerID
  // return list only those companies which are added by current job's employer
  const conpaniesOptions = companiesList.data
    .filter(({userId}) => userId === jobDetails.employer._id)
    .map(({_id, name}) => ({
      value: _id,
      label: name,
    }));

  return (
    <JobForm
      jobDetails={jobDetails}
      skillList={skillList}
      conpaniesOptions={conpaniesOptions}
    />
  );
};

export default EditJob;
